<template>
  <div class="file-list">
    <h2>
      Arquivos anexos
      <span
        v-if="showFeedback()"
        class="limit-feedback"
      >
        Limite de 3 arquivos
      </span>
      <div class="feedback-icon">
        <img src="/static/images/icon-feedback-upload.svg">
        <md-tooltip md-direction="right">
          Para enviar mais de 3 arquivos,<br> use arquivos compactados<br> formato .ZIP ou .RAR
        </md-tooltip>
      </div>
    </h2>
    <div class="loop">
      <template v-for="file in pendency.files">
        <template v-if="file.error">
          <file-box-failed
            v-if="pendency.files.length > 1"
            :key="file.id"
            @try-again="handleTryAgain(file)"
          />
          <div
            v-else
            :key="file.id"
            class="file-error"
          >
            <div class="error-row">
              <img
                src="/static/images/icon-alert-upload.svg"
                alt="icone"
              >
              Não foi possível fazer o upload
            </div>
            <button @click="handleTryAgain(file)">
              TENTAR NOVAMENTE
            </button>
          </div>
        </template>

        <template v-else>
          <file-box-success
            v-if="file.success || file.uuid"
            :key="setId(file)"
            :file-name="setName(file)"
            :file-id="setId(file)"
            :pendency-id="pendency.id"
            :delete-btn-enabled="showDelete()"
          />
          <file-box-loading
            v-else
            :key="file.id + 1"
          />
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import FileBoxSuccess from './FileBox/Success'
import FileBoxFailed from './FileBox/Failed'
import FileBoxLoading from './FileBox/Loading'

export default {
  name: 'UploadList',
  components: {
    'file-box-success': FileBoxSuccess,
    'file-box-failed': FileBoxFailed,
    'file-box-loading': FileBoxLoading
  },
  props: {
    pendency: {
      default: null
    }
  },
  computed: {
    ...mapGetters(['pendencyFiles', 'uploadLimit']),
  },
  methods: {
    ...mapActions(['deleteStoreFile']),
    handleTryAgain(file) {
      this.deleteStoreFile({ id: file.id, pendencyId: this.pendency.id })
    },
    setName(file) {
      return file.file_name_original ? file.file_name_original : file.name
    },
    setId(file) {
      return file.id_file ? file.id_file : file.id
    },
    showDelete() {
      if (this.pendency.status === 'R') {
        return false
      }
      return true
    },
    showFeedback() {
      let files = this.pendency.files
      if (files && files.length >= this.uploadLimit) return true
      return false
    }
  }
}
</script>

<style lang="scss">
.file-list {
  h2 {
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    color: #4a4a4a;
    text-align: left;
    margin-bottom: 10px;
  }

  .feedback-icon {
    float: right;
  }

  .limit-feedback {
    color: #E2245A;
    font-size: 14px;
    font-weight: normal;
    letter-spacing: 0;
  }

  .loop {
    .file-error {
      text-align: center;
      padding: 30px 0;

      img {
        margin-right: 3px;
        position: relative;
        top: -2px;
      }

      .error-row {
        color: #B40607;
        text-align: center;
        font-size: 12px;
        margin-bottom: 20px;
      }

      button {
        color: #7F1A54;
        background-color: transparent;
        font-size: 12px;
        border: 1px solid #7F1A54;
        padding: 5px 20px;
        height: auto;
        border-radius: 5px;
      }
    }

    >div {
      margin-bottom: 10px;
    }

    >div:last-of-type {
      margin-bottom: 0;
    }
  }
}
</style>
